import React, { forwardRef, memo } from 'react'

const NetworkNodesIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="29.4"
    height="29.4"
    viewBox="0 0 42 42"
    fill="none"
    {...props}>
    <path
      d="M13.5715 18.6741C16.3893 18.6741 18.6736 16.3898 18.6736 13.572C18.6736 10.7542 16.3893 8.46997 13.5715 8.46997C10.7537 8.46997 8.46948 10.7542 8.46948 13.572C8.46948 16.3898 10.7537 18.6741 13.5715 18.6741Z"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8777 18.6741C31.6955 18.6741 33.9797 16.3898 33.9797 13.572C33.9797 10.7542 31.6955 8.46997 28.8777 8.46997C26.0599 8.46997 23.7756 10.7542 23.7756 13.572C23.7756 16.3898 26.0599 18.6741 28.8777 18.6741Z"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5715 33.9802C16.3893 33.9802 18.6736 31.6959 18.6736 28.8782C18.6736 26.0604 16.3893 23.7761 13.5715 23.7761C10.7537 23.7761 8.46948 26.0604 8.46948 28.8782C8.46948 31.6959 10.7537 33.9802 13.5715 33.9802Z"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8777 23.7761V33.9802"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.9797 28.8779H23.7756"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

NetworkNodesIcon.displayName = 'NetworkNodesIcon'

export default memo(NetworkNodesIcon)
